import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DiscordOutlinedSvg from "@ant-design/icons-svg/es/asn/DiscordOutlined";
import AntdIcon from "../components/AntdIcon";
var DiscordOutlined = function DiscordOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DiscordOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DiscordOutlined.displayName = 'DiscordOutlined';
}
export default /*#__PURE__*/React.forwardRef(DiscordOutlined);